module.exports = __webpack_public_path__ + "img/128ne.6a3daa0a.svg";